import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { FilterType, TableParams } from '@app/core/models';
import { ApiUrlService } from '../common/api-url.service';
import { TranslationsService } from '../common/translations.service';

export interface FilterData {
  id: number;
  name: string;
}

@Injectable({providedIn: 'root'})
export class ApiFilterService {
  constructor(protected httpClient: HttpClient,
              protected apiUrlService: ApiUrlService,
              private language: TranslationsService) {
  }

  get url(): string {
    return this.apiUrlService.getApiUrl() + 'client/dictionary/';
  }

  getList(string: FilterType, data?: TableParams | undefined): Observable<FilterData[]> {
    const fullPath = this.url + string;
    return this.httpClient.get<any>(fullPath).pipe();
  }
}
